import React from "react";
import { Carousel } from "./Carousel";
import type { StoryImage } from "../data/story";
type StoryChapterProps = {
  stage: string;
  title: string;
  images?: StoryImage[];
  reverse?: boolean;
  children: React.ReactNode;
};
export function StoryChapter({
  stage,
  title,
  images,
  reverse,
  children
}: StoryChapterProps) {
  const text = <>
      <p className="font-display text-sm font-bold uppercase text-accent" data-id="element-254" data-mp="1ea80pbg5wt55">{stage}</p>
      <h3 className="mt-3 font-display text-3xl font-extrabold uppercase leading-[1.05] md:text-4xl" data-id="element-255" data-mp="1sznp4ks80mho">{title}</h3>
      <div className="mt-6 space-y-3 text-lg leading-relaxed text-paper/80" data-id="element-256" data-mp="1o48dlzhor2of">{children}</div>
    </>;
  if (!images || images.length === 0) {
    return <div className="max-w-3xl" data-id="element-257" data-mp="1x2kbmmkvt2qw">{text}</div>;
  }
  return <div className="grid items-center gap-10 md:grid-cols-2 md:gap-16" data-id="element-258" data-mp="1x0zjf3m1hvw7">
      <div className={`min-w-0 ${reverse ? "md:order-2" : ""}`} data-id="element-259" data-mp="7oe2w31a91at">
        <Carousel images={images} label={`Fotos: ${stage}`} data-id="element-260" data-mp="2pks4iddroec" />
      </div>
      <div className={reverse ? "md:order-1" : ""} data-id="element-261" data-mp="2n8ivzucv9etf">{text}</div>
    </div>;
}